import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-h-primary-50 border py-2"
}
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = {
  key: 1,
  class: "container mx-auto flex w-12/12 sm:w-10/12 lg:w-8/12 justify-center my-10"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex justify-between items-center mb-10" }
const _hoisted_6 = { class: "text-xl md:text-2xl font-bold" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "flex flex-col gap-10" }
const _hoisted_9 = { class: "flex flex-col gap-5" }
const _hoisted_10 = { class: "flex flex-col gap-3" }
const _hoisted_11 = { class: "font-bold text-lg" }
const _hoisted_12 = { class: "p-5 bg-white rounded-md shadow-sm border" }
const _hoisted_13 = { id: "prompt" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "flex flex-row items-center gap-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg col-span-12 my-5" }, "Itens", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-sm text-h-error-400"
}
const _hoisted_18 = { class: "p-5 bg-white rounded-md shadow-sm border col-span-10 mb-5" }
const _hoisted_19 = {
  id: "enunciated-item",
  class: "mb-1"
}
const _hoisted_20 = {
  id: "item-action",
  class: "col-span-2 flex flex-col justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress",
      loaderSize: "h-96"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BreadcrumbComponent, {
              home: _ctx.home,
              items: _ctx.items
            }, null, 8, ["home", "items"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitQuestion && _ctx.submitQuestion(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$route.params.id
                  ? _ctx.$t("quiz.teacher.edit")
                  : _ctx.$t("quiz.teacher.add")), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Button, {
                    id: "btn-cancel",
                    label: _ctx.$t('labels.cancel'),
                    class: "btn-outline p-button-sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmModal()))
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    id: "btn-submit-questions",
                    label: _ctx.$t('labels.save'),
                    class: "btn-primary p-button-sm",
                    type: "submit"
                  }, null, 8, ["label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("question.prompt.title")), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("question.prompt.title")), 1),
                        _createVNode(_component_Textarea, {
                          id: "description-input",
                          autoResize: true,
                          rows: "5",
                          cols: "30",
                          placeholder: _ctx.$t('question.prompt.empty'),
                          modelValue: _ctx.form.prompt,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.prompt) = $event)),
                          class: _normalizeClass(_ctx.v$.form.prompt.$error ? 'p-invalid' : ''),
                          maxlength: 999
                        }, null, 8, ["placeholder", "modelValue", "class"]),
                        _createVNode(_component_Errors, {
                          errors: _ctx.v$.form.prompt.$errors,
                          actualLength: _ctx.form.prompt?.length,
                          maxLength: 999
                        }, null, 8, ["errors", "actualLength"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      (_ctx.selectCorrect)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("labels.generic", {
                        pt: "Você deve indicar qual o item correto",
                        en: "You must indicate which item is correct",
                      })), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.items, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        id: "item-question",
                        class: "grid grid-cols-12 gap-3",
                        key: i
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_Textarea, {
                              id: "question-input",
                              autoResize: true,
                              rows: "3",
                              cols: "30",
                              placeholder: _ctx.$t('question.prompt.items.empty'),
                              modelValue: item.answerText,
                              "onUpdate:modelValue": ($event: any) => ((item.answerText) = $event),
                              class: _normalizeClass(
                          _ctx.v$.form.items.$each.$response.$errors[i].answerText
                            ?.length !== 0 && _ctx.v$.form.$error
                            ? 'p-invalid'
                            : ''
                        ),
                              maxlength: 999
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"]),
                            _createVNode(_component_Errors, {
                              errors: 
                          _ctx.v$.form.items.$each.$response.$errors[i].answerText
                        ,
                              actualLength: item.answerText?.length,
                              maxLength: 999
                            }, {
                              msg: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.v$.form.$error ? _ctx.$t("validations.required") : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["errors", "actualLength"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_v_icon, {
                            name: "hi-solid-check-circle",
                            class: _normalizeClass(`${
                        item.id === _ctx.form.correctItem?.id || item.correct
                          ? 'text-h-success-400'
                          : 'text-gray-400'
                      } cursor-pointer hover:scale-95 transition-all ${
                        _ctx.v$.form.items.$each.$response.$errors[i].correct
                          ?.length !== 0 && _ctx.v$.form.$error
                          ? 'border-2 border-red-500 rounded-full'
                          : ''
                      }`),
                            scale: 
                        item.id === _ctx.form.correctItem?.id ? 4 : 3 || item.correct
                      ,
                            onClick: ($event: any) => (_ctx.chooseCorrectItem(item, _ctx.form.items))
                          }, null, 8, ["class", "scale", "onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog)
  ]))
}